(function(){
  'use strict';

  var LOCK_SVG_PATH = 'M5.83333 6.66675V5.83341C5.83333 4.74781 5.83333 4.205 5.97218 3.76463C6.26651 2.83114 6.99772 2.09993 7.93122 1.8056C8.37159 1.66675 8.91439 1.66675 10 1.66675V1.66675C11.0856 1.66675 11.6284 1.66675 12.0688 1.8056C13.0023 2.09993 13.7335 2.83114 14.0278 3.76463C14.1667 4.205 14.1667 4.74781 14.1667 5.83341V6.66675M10 11.6667V13.3334M8.33333 18.3334H11.6667C13.3741 18.3334 14.2278 18.3334 14.909 18.077C15.9871 17.6713 16.8379 16.8205 17.2436 15.7424C17.5 15.0612 17.5 14.2075 17.5 12.5001V12.5001C17.5 10.7926 17.5 9.93892 17.2436 9.25775C16.8379 8.17969 15.9871 7.32888 14.909 6.92312C14.2278 6.66675 13.3741 6.66675 11.6667 6.66675H8.33333C6.62589 6.66675 5.77218 6.66675 5.091 6.92312C4.01294 7.32888 3.16213 8.17969 2.75638 9.25775C2.5 9.93892 2.5 10.7926 2.5 12.5001V12.5001C2.5 14.2075 2.5 15.0612 2.75638 15.7424C3.16213 16.8205 4.01294 17.6713 5.091 18.077C5.77218 18.3334 6.62589 18.3334 11.6667 18.3334Z';

  function injectLockIcon(el){
    if (!el || el.querySelector('svg[data-scala-fix-icon]')) return;
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('slot', 'icon');
    svg.setAttribute('data-scala-fix-icon', '');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'margin-right: 0.5rem; flex-shrink: 0; display: inline-block; vertical-align: middle;';
    var path = document.createElementNS(svgNS, 'path');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('d', LOCK_SVG_PATH);
    svg.appendChild(path);
    el.appendChild(svg);
  }

  function fixScalaButton(){
    var elements = document.querySelectorAll('scala-cart-button, scala-button, scala-finalizar-compra-restrict, scala-button-restrict');

    elements.forEach(function(el){
      try {
        el.style.display = 'block';
        el.style.width = '100%';
        el.style.marginTop = '0.5rem';
        el.style.marginBottom = '0';
      } catch(e){}

      injectLockIcon(el);

      if (el.shadowRoot) {
        var btn = el.shadowRoot.querySelector('#scala-button, button[part="actualbutton"], button');
        if (btn) {
          try {
            btn.style.setProperty('--width', '100%', 'important');
            btn.style.setProperty('--height', 'auto', 'important');
            btn.style.setProperty('--min-height', '52px', 'important');
            btn.style.setProperty('--padding', '1rem 1.5rem', 'important');
            btn.style.setProperty('--border-radius', '9999px', 'important');
            btn.style.setProperty('width', '100%', 'important');
            btn.style.setProperty('min-width', '100%', 'important');
            btn.style.setProperty('box-sizing', 'border-box', 'important');
            btn.style.setProperty('display', 'flex', 'important');
            btn.style.setProperty('align-items', 'center', 'important');
            btn.style.setProperty('justify-content', 'center', 'important');
          } catch(e){}
        }
      }

      var lightBtn = el.querySelector('button, #scala-button');
      if (lightBtn) {
        try {
          lightBtn.style.setProperty('width', '100%', 'important');
          lightBtn.style.setProperty('min-width', '100%', 'important');
        } catch(e){}
      }
    });
  }

  function init(){
    fixScalaButton();
    setTimeout(fixScalaButton, 100);
    setTimeout(fixScalaButton, 500);
    setTimeout(fixScalaButton, 1000);
    setTimeout(fixScalaButton, 2000);
    setTimeout(fixScalaButton, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);

  var observer = new MutationObserver(function(mutations){
    var hasChange = false;
    mutations.forEach(function(m){
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(function(n){
          if (n.nodeType === 1) {
            var tag = (n.tagName || '').toLowerCase();
            if (tag.indexOf('scala') !== -1) hasChange = true;
            else if (n.querySelector && n.querySelector('scala-cart-button, scala-button')) hasChange = true;
          }
        });
      }
    });
    if (hasChange) {
      setTimeout(fixScalaButton, 50);
      setTimeout(fixScalaButton, 250);
      setTimeout(fixScalaButton, 800);
    }
  });

  function startObserver(){
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);

  ['click', 'cart:open', 'cart:refresh', 'cart:updated', 'cart:opened'].forEach(function(ev){
    document.addEventListener(ev, function(){
      setTimeout(fixScalaButton, 50);
      setTimeout(fixScalaButton, 300);
      setTimeout(fixScalaButton, 800);
    }, true);
  });

  window.scalaFixDebug = function(){
    var els = document.querySelectorAll('scala-cart-button, scala-button');
    console.log('[scala-fix] Found', els.length, 'scala elements');
    els.forEach(function(el, i){
      console.log('[scala-fix]', i, el.tagName, el);
      if (el.shadowRoot) {
        var b = el.shadowRoot.querySelector('#scala-button, button');
        console.log('[scala-fix]   shadow button:', b);
      }
    });
    fixScalaButton();
    console.log('[scala-fix] reapplied');
  };
  console.log('[scala-fix] v4 loaded (with lock icon)');
})();
